export const SUBSCRIPTION_PLAN_LIST = "SUBSCRIPTION_PLAN_LIST";
export const SUBSCRIPTION_PLAN_LIST_DATA = "SUBSCRIPTION_PLAN_LIST_DATA";
export const SUBSCRIPTION_PLAN_LIST_ERROR = "SUBSCRIPTION_PLAN_LIST_ERROR";
export const MY_SUBSCRIPTION = "MY_SUBSCRIPTION";
export const MY_SUBSCRIPTION_DATA = "MY_SUBSCRIPTION_DATA";
export const MY_SUBSCRIPTION_ERROR = "MY_SUBSCRIPTION_ERROR";
export const MY_UPGRADE_PLAN_DATA = "MY_UPGRADE_PLAN_DATA";
export const MY_UPGRADE_PLAN_DATA_ERROR= "MY_UPGRADE_PLAN_DATA_ERROR";
export const MY_UPGRADE_PLAN = "MY_UPGRADE_PLAN";
